import styled, { keyframes } from 'styled-components';

const dots = keyframes`
   0% {
      opacity: 0.4;
      transform: scale(1, 1);
    }

    50% {
      opacity: 1;
      transform: scale(1.2, 1.2);
    }

    100% {
      opacity: 0.4;
      transform: scale(1, 1);
    }
`;

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  div {
    background-color: ${({ color, theme }) => color || theme.colors.primary};
  }
`;

export const Ball = styled.div`
  margin: 2px;
  animation: ${dots} 1.5s infinite ease-in-out;
  border-radius: 10px;
  display: inline-block;
  height: 8px;
  width: 8px;

  &:nth-child(2) {
    animation-delay: 0.5s;
  }

  &:nth-child(3) {
    animation-delay: 1s;
  }
`;

export default {};
